import {useCallback} from 'react';
import {useSelector} from 'react-redux';

import {getCommonLimits} from 'src/openapi/admin/apis/GetCommonLimitsApi';
import {useAppDispatch} from 'src/store/hooks';

import {selectLicenseCommonLimits} from './services/dictionary-slice';

export const useLicenseCommonLimits = () => {
    const apiDispatch = useAppDispatch();
    const licenseCommonLimits = useSelector(selectLicenseCommonLimits);

    const loadLicenseCommonLimits = useCallback(() => {
        if (!licenseCommonLimits.length) {
            apiDispatch(getCommonLimits());
        }
    }, [licenseCommonLimits.length, apiDispatch]);

    const getCommonLimitsIds = useCallback(() => {
        return licenseCommonLimits.reduce<Array<string>>((acc, item) => {
            if (item.children) {
                return [...acc, ...(item.children.map(e => e.code))];
            }
            return acc;
        }, [] as Array<string>);
    }, [licenseCommonLimits]);

    return {licenseCommonLimits, loadLicenseCommonLimits, getCommonLimitsIds};
};
